"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable react-hooks/rules-of-hooks, react-hooks/exhaustive-deps */
var React = __importStar(require("react"));
function useControlled(_a) {
    var controlled = _a.controlled, defaultProp = _a.default, name = _a.name, _b = _a.state, state = _b === void 0 ? 'value' : _b;
    // isControlled is ignored in the hook dependency lists as it should never change.
    var isControlled = React.useRef(controlled !== undefined).current;
    var _c = __read(React.useState(defaultProp), 2), valueState = _c[0], setValue = _c[1];
    var value = isControlled ? controlled : valueState;
    if (process.env.NODE_ENV !== 'production') {
        React.useEffect(function () {
            if (isControlled !== (controlled !== undefined)) {
                console.error([
                    "A component is changing the ".concat(isControlled ? '' : 'un', "controlled ").concat(state, " state of ").concat(name, " to be ").concat(isControlled ? 'un' : '', "controlled."),
                    'Elements should not switch from uncontrolled to controlled (or vice versa).',
                    "Decide between using a controlled or uncontrolled ".concat(name, " ") +
                        'element for the lifetime of the component.',
                    "The nature of the state is determined during the first render. It's considered controlled if the value is not `undefined`.",
                    'More info: https://fb.me/react-controlled-components',
                ].join('\n'));
            }
        }, [state, name, controlled]);
        var defaultValue_1 = React.useRef(defaultProp).current;
        React.useEffect(function () {
            if (!isControlled && defaultValue_1 !== defaultProp) {
                console.error([
                    "A component is changing the default ".concat(state, " state of an uncontrolled ").concat(name, " after being initialized. ") +
                        "To suppress this warning opt to use a controlled ".concat(name, "."),
                ].join('\n'));
            }
        }, [JSON.stringify(defaultProp)]);
    }
    var setValueIfUncontrolled = React.useCallback(function (newValue) {
        if (!isControlled) {
            setValue(newValue);
        }
    }, []);
    // @ts-ignore
    return [value, setValueIfUncontrolled];
}
exports.default = useControlled;
//# sourceMappingURL=useControlled.js.map